
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { format, utcToZonedTime } from 'date-fns-tz';
import { statesTimeZonesList, timeZoneDefault } from '@/utils/PortalConstants';
import dp from 'date-fns/parse';

@Component({})
export default class TDatepickerDateField extends Vue {
  @Prop(String) public value: string;
  @Prop(String) public state: string;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  public dateString = '';
  public secondsString = '';
  public zoneString = '';

  get fieldValue() {
    const stopTimeZone = statesTimeZonesList[this.state]?.timezone || timeZoneDefault;
    let date: Date;
    if (this.value) {
      date = utcToZonedTime(new Date(this.value), stopTimeZone);
    } else {
      date = utcToZonedTime(new Date(), stopTimeZone);
    }
    const value = format(date, 'hh:mm aa');
    this.dateString = format(date, 'yyyy-MM-dd', { timeZone: stopTimeZone });
    this.secondsString = format(date, 'ss', { timeZone: stopTimeZone });
    this.zoneString = format(date, 'xxxxx', { timeZone: stopTimeZone });
    return value;
  }

  set fieldValue(value) {
    if (value) {
      const dateFromTime = dp(value, 'hh:mm aa', new Date());
      value = format(dateFromTime, 'HH:mm');
      value = this.dateString + 'T' + value + ':' + this.secondsString + this.zoneString;
    }
    this.$emit('input', value || '');
  }

  public handleChange(value: string | null) {
    if (!value) {
      value = '';
    }
    this.$emit('change', value);
  }
}
